import { useFormikContext } from 'formik';
import React, { ReactElement, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { InputAutocompleteMulti } from '@innovyze/stylovyze';
import { Option } from '@innovyze/stylovyze';

import { getValue } from '@Selectors';
import { useGlobalization } from '@Translations/useGlobalization';
import { subscriptionsList } from '@Types/entitlements.types';
import { User } from '@Types/user.types';
import { useCreateUserContext } from '../../contexts/CreateUserContext';

export default function UserEntitlementsField(): ReactElement {
	const { values } = useFormikContext<User>();
	const { t } = useGlobalization();

	// selectors
	const { userErrors } = useCreateUserContext();
	const productsNames = useSelector(getValue).products.list.map(
		el => el.name,
	);

	// derived values
	const blocked = !!values?.blocked;
	const options = useMemo(
		() =>
			Array.isArray(subscriptionsList(t))
				? subscriptionsList(t)
						?.filter(el => productsNames?.includes(el.key))
						.map(
							el =>
								({
									key: el.key,
									value: el.value,
								} as Option),
						)
				: [],
		[productsNames, t, values.entitlements],
	);

	return (
		<InputAutocompleteMulti
			fieldAttrs={{
				name: 'entitlements',
				disabled: blocked,
			}}
			autocompleteProps={{ disableCloseOnSelect: true, limitTags: 4 }}
			options={options}
			label={t('Subscriptions')}
			dataCy="entitlements"
			error={!!userErrors.entitlements}
			helperText={userErrors.entitlements}
		/>
	);
}
